import { useSyncExternalStore } from 'react';
import { DEFAULT_THEME, getTheme, subscribeTheme, type Theme } from './theme.js';

/** The live theme, as React state. No provider needed — the store is the DOM. */
export function useTheme(): Theme {
  return useSyncExternalStore(subscribeTheme, getTheme, () => DEFAULT_THEME);
}
